import { useState } from 'react';
export const useMap = () => {
    const [map, setMap] = useState(new Map());
    return [map, {
            has: (key) => map.has(key),
            set: (key, value) => setMap(map => new Map(map.set(key, value))),
            get: (key) => map.get(key),
            del: (key) => {
                let existed = false;
                setMap(map => { existed = map.delete(key); return new Map(map); });
                return existed;
            },
            clear: () => setMap(new Map())
        }];
};
